import { LocalDate } from '../../../models';
import { DateWithTimezones } from '../../../../common/models/status-history-chain.model';

export interface LatestNotification {
  reason: string;
  actualArrivalTime: DateWithTimezones | LocalDate | number;
}
